import { useSelector } from "react-redux"
import { getTranslated } from "../../utils/CommonUtils"
import { CHECKBOX } from "../../utils/Constants"
import UMCAttributeView from "./UMCAttributeView"
import { Tooltip } from "antd"
import { InfoCircleFilled } from "@ant-design/icons"
import { PURPLE } from "../../styles/styleUtils"

/**
 * Component to display Label - Widget pair in a single line [horizontal]
 * @param {*} attribute 
 * @returns 
 */
const UMCHoriAttrCompView = ({ attribute }) => {

    const dict = useSelector(state => state.common.dict)

    return <div className="attr-horizontal-wrap">

        {(attribute.label) ?
            <div className={`attr-horizon-label ${attribute.mandatory ? "mandatory-field" : ""}`}>
                {getTranslated(dict, attribute.label)}:{(attribute.help) ?
                    <Tooltip title={getTranslated(dict, attribute.help)}>
                        <InfoCircleFilled style={{ color: PURPLE, paddingLeft: "5px" }} />
                    </Tooltip> :
                    <></>}
            </div> : <></>}
        <UMCAttributeView // Attribute widget
            attribute={{ ...attribute, label: attribute.widget === CHECKBOX ? "" : attribute.label }} // UMCCheckbox shows label beside[right] to checkbox, overide it by sending empty label
        />
    </div>
}

export default UMCHoriAttrCompView